import React from 'react';

const defaultState = {
    form: undefined,
    handleSubmit: ()=>undefined,
    size: undefined,
    readOnly: undefined,
    __virtual: false,
    itemTemplate: undefined
};
const FormContext = React.createContext(defaultState);

export { FormContext };
//# sourceMappingURL=FormContext.js.map
